import { createIdFromContent } from '@utils/createIdFromContent';
import { MouseEvent, useCallback } from 'react';
import { Container, List, ListItem, StyledH2 } from './Contents.styles';
import { ContentsProps } from './Contents.types';

export const Contents = ({ elements }: ContentsProps) => {
  const handleClick = useCallback((e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    document.querySelector(e.currentTarget.getAttribute('href'))?.scrollIntoView({
      behavior: 'smooth',
    });
  }, []);

  return (
    <Container>
      <StyledH2>In This Article</StyledH2>
      <List>
        {elements.map((element) => (
          <ListItem key={element}>
            <a href={`#${createIdFromContent(element)}`} onClick={handleClick}>
              {element}
            </a>
          </ListItem>
        ))}
      </List>
    </Container>
  );
};
